import { useEffect, useState } from "react"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { _QuickturnAppointment } from "../../../../../../core/services/dataBean/QuickEntityCatalog"
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog"
import { toast } from "react-toastify"
import { Alert } from "../../../../../../modules/theme/Component/Alert"

export const ActiveAppointments = () => {

    const { instance, bean, setBean } = useDataBean(_QuickturnAppointment)
    const [lista, setLista] = useState<any[]>([]);

    useEffect(() => { getLista() }, [])

    const getLista = () => {
        instance.getAppointmentByAccount(null, null, _single.getAccountID(), 0).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => toast.error(err))
    }

    const initTurn = (appoint: any) => {
        instance.createAttentionTicketFromAppointment(appoint.IDAppointment, _single.getCurrenDate()).then(
            (resp) => {
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const cancelTurn = (appoint: any) => {
        instance.cancelAppointment(appoint.IDAppointment, appoint.AgendaRequestDate, _single.getAccountID(), "").then(
            (resp) => {
                getLista();
            }
        ).catch(resp => { toast.error(resp) })
    }

    return lista.length > 0 ? (
        <div className="appointment-list">
            {lista.map((item, index) => {
                const data = item.DataBeanProperties;

                const fromHour = data.FromDate?.split(" ")[1]?.substring(0, 5);
                const untilHour = data.UntilDate?.split(" ")[1]?.substring(0, 5);

                return (
                    <div className="appointment-card" key={index}>
                        <div className="icon-col">
                            <div className="icon-circle">
                                <i className="ri-calendar-check-line"></i>
                            </div>
                        </div>

                        <div className="content-col">
                            <h6 className="title">{data.AttentionIDName}</h6>

                            <div className="subinfo">
                                <span className="label">{data.AttentionOfficeName}</span>
                            </div>

                            <div className="subinfo">
                                <span className="date">{data.FromDate.split(" ")[0]}</span>
                                <span className="hour">{fromHour} - {untilHour}</span>
                            </div>

                            <div className="subinfo">
                                <span className={`state state-${data.ProcessState}`}>
                                    {data.ProcessStateName}
                                </span>
                            </div>

                            <div className="actions">
                                <button className="btn-cancel" onClick={() => cancelTurn(data)}>Cancelar</button>
                                <button className="btn-here" onClick={() => initTurn(data)}>Estoy aquí</button>
                            </div>

                        </div>

                    </div>
                );
            })}
        </div>
    ) :
        <Alert children={`Sin agendamientos`} clase="info" />
}